import { ICoreContext } from '@msdyn365-commerce/core';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';
import { IGetDirectLineTokenData } from '../../actions/get-direct-line-token.action';
import { IUserRoleState } from '../../states/user-role-state';
import { ILxsServiceAgentProps } from './lxs-service-agent.props.autogenerated';

export const INCOMING_ACTIVITY = 'DIRECT_LINE/INCOMING_ACTIVITY';
export const SET_CONTEXT_EVENT = 'pvaSetContext';
export const HTTPS = 'https://';
export const START_CONVERSATION_EVENT = 'startConversationPortal';
export const CONVERSATION_TYPE_EVENT = 'event';
export const MAX_TRANSCRIPT_COUNT = 200;
export const CONNECTION_STATUS_CONNECTED = 2;
export const STORAGE_KEY = 'webchatConversation';

export interface ILxsServiceAgentData {
    getDirectLineToken: AsyncResult<IGetDirectLineTokenData>;
    userRoleState: AsyncResult<IUserRoleState>;
}

export interface InitWebChatParams {
    directLineToken: string;
    savedConversation: IStoredConversation | null;
    userToken: string;
    userName: string | undefined;
    locale: string;
    container: HTMLDivElement;
    writeStoredConversation: (conversation: IStoredConversation) => void;
}

export interface ILxsServiceAgentViewProps extends ILxsServiceAgentProps<ILxsServiceAgentData> {
    fetchDirectLineToken: (context: ICoreContext) => Promise<string | null>;
    readStoredConversation: () => IStoredConversation | null;
    writeStoredConversation: (conversation: IStoredConversation) => void;
    clearStoredConversation: () => void;
    getValidStoredConversation: (directLineToken: string, userToken: string) => IStoredConversation | null;
    CLASS_NAME: string;
}

export interface IStoredConversation {
    conversationId: string;
    directLineToken: string;
    userToken: string;
    transcript: any[];
}

declare global {
    interface Window {
        WebChat?: any;
    }
}

declare global {
    interface Window {
        WebChat?: any;
    }
}
